export default __webpack_public_path__ + "static/media/scleton1.0ad407c4.jpg";